import { useEffect } from 'preact/hooks';
import { styled } from 'goober';

const Container = styled('div')`
  position: relative;
`;

const ToolTipPromptContainer = styled('div')`
  display: ${(props) => (props.showMsg ? 'block' : 'none')};
`;

const ToolTipPromptTxt = styled('div')`
  color: #fff;
  text-align: center;
  padding: 8px;
  border-radius: 8px;
  color: black;
  background-color: white;
  border: 1px solid #fff0ca;
  box-shadow: 2px 1px 16px -4px rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 350px;
  bottom: ${(props) => (props.shouldModifyCss ? '61px' : '100%')};
  left: ${(props) => (props.shouldModifyCss ? 'unset' : '35%')};
  right: ${(props) => (props.shouldModifyCss ? '-170px' : 'unset')};
  display: flex;
  flex-direction: column;
  font-size: 12px;
  z-index: 999;

  &::after {
    display: ${(props) => (props.shouldDisablePointer ? 'none' : 'inline')};
    content: ' ';
    position: absolute;
    top: calc(100% + 1px); /* At the bottom of the tipContainer */
    left: 50%;
    margin-left: -5px;
    border-width: 7px;
    border-style: solid;
    border-color: gray transparent transparent transparent;
    overflow-wrap: break-word;
  }
  @media only screen and (max-width: 600px) {
    left: ${(props) => (props.shouldModifyCss ? 'unset' : '20%')};
    right: ${(props) => (props.shouldModifyCss ? '-87px' : 'unset')};
    width: ${(props) => (props.shouldModifyCss ? '291px' : '120px')};
    height: fit-content;
    font-size: 12px;
    top: ${(props) => (props.shouldModifyCss ? '120%' : '85%')};
    z-index: 999;
    &::after {
      bottom: calc(100% + 1px); /* At the top of the tipContainer */
      top: unset;
      border-color: transparent transparent grey transparent;
      left: ${(props) => (props.shouldModifyCss ? '69%' : '46%')};
      z-index: 999;
    }
  }

  @media only screen and (max-width: 399px) {
    width: ${(props) => (props.shouldModifyCss ? '291px' : '120px')};
    height: ${(props) => (props.shouldModifyCss ? '103px' : 'fit-content')};
  }
`;

const ToolTipPromptComponent = ({
  showMsg,
  clearMsg,
  msg,
  children,
  shouldModifyCss,
  shouldUseAutoTimer,
  inlineStyle,
  shouldDisablePointer,
  infoIconStyle,
}) => {
  useEffect(() => {
    if (showMsg) {
      if (shouldUseAutoTimer) {
        setTimeout(() => {
          clearMsg();
        }, 2500);
      }
    }
  }, [showMsg]);

  return (
    <Container>
      <ToolTipPromptContainer showMsg={showMsg}>
        <ToolTipPromptTxt
          shouldModifyCss={shouldModifyCss}
          shouldDisablePointer={shouldDisablePointer}
          style={inlineStyle && inlineStyle}>
          <span
            class='material-icons'
            style={{ ...infoIconStyle, color: '#F3A939', fontSize: '20px' }}>
            info
          </span>
          {msg}
        </ToolTipPromptTxt>
      </ToolTipPromptContainer>
      <div>{children}</div>
    </Container>
  );
};

export default ToolTipPromptComponent;



// WEBPACK FOOTER //
// ./components/common/toolTipPromptComponent/index.js